export const colTypesWidths = {
  w50: {
    width: 50,
  },
  w100: {
    width: 100,
  },
  w120: {
    width: 120,
  },
  w150: {
    width: 150,
  },
  w200: {
    width: 200,
  },
};
